import '../../../generic_social_content_view.js.coffee'
Namespace 'Customer.Ticket'

class Customer.Ticket.InteractionView extends Monitoring.Views.GenericSocialContentView
  template: JST['backbone/templates/customer/ticket/body/interaction']
  responseTemplate: JST['backbone/templates/customer/ticket/body/response']

  className: 'clearfix interaction-and-schedule'
  viewType: 'interaction'

  events:
    'click .follow': 'onFollow'
    'click .retweet': 'onRetweet'
    'click .favorite': 'onFavorite'
    'click .like': 'onLike'
    'click .unlike': 'onUnlike'
    'click .react': '_onReact'
    'click .unreact': '_onUnreact'
    'click .openResponseBox': 'openResponseBox'
    'click .closeResponseBox': 'closeResponseBox'
    'click .video-preview': 'showVideo'
    'click .show-context': 'showContext'
    'click .add-new-tags': 'editTags'
    'click .edit-tags-action' : 'editTags'
    'click .edit-whatsapp-tags-action' : 'editTags'
    'click .cut-ticket-action' : 'cutTicket'
    'mouseenter .cut-ticket-action': 'onMouseOverCutTicket'
    'mouseleave .cut-ticket-action': 'onMouseOutCutTicket'
    'click .print-action' : 'printInteraction'
    'hide [id^=modal-video]': 'pauseVideo'
    'click .audio-preview': 'showAudio'
    'hide [id^=modal-audio]': 'pauseAudio'
    'click .text-with-html': 'switchToTextWithHtml'
    'click .text-without-html': 'switchToTextWithoutHtml'
    'click .attachment-scroll-backwards': 'scrollAttachmentsBackwards'
    'click .attachment-scroll-forwards': 'scrollAttachmentsForwards'
    'click .attributes': 'onPermalink'

  formContainerSelector: '.form-container:not(.child-form-container)'

  ticketType: ->
    'interaction'

  initialize: (@options = {}) ->
    @ticketView = @options.ticketView || @options.interactionsView.ticketView
    @template = @findTemplate()
    @ticket = @ticketView.getTicket()
    @interactionVisualizationDefault = @options.interactionVisualizationDefault || {}
    @userProfileData = @options.userProfileData
    @interaction = new Customer.Interaction(
      conversation: @ticket
      interactionId: @model.get('interaction_id')
      socialContentId: @model.get('id')
      possibleTags: @model.possibleTags()
      privateInteractionOnPublicContent: @firstInteractionIsPublic() && @isPrivateMessage()
      interactionType: @options.interactionType
      socialAccounts: @model.get('social_accounts')
      enabled_email_social_accounts: @options.enabled_email_social_accounts
      replyButtonEnabled: @model.get('reply_button_enabled')
    )
    @childSocialContents = _.map @model.get('children'), (childSocialContentObject) =>
      new Monitoring.Models.SocialContents.AnalysisUnitFactory().create(childSocialContentObject, @ticketView.model.tags)
    @listenTo(@model, 'change:data', => @render(false))
    @listenTo(@interaction, 'interaction:update:success', @_onUpdateSuccess)
    @listenTo(@interaction, 'interaction:update:error', @_onUpdateError)
    @listenTo(@interaction, 'interaction:follow', =>
      @$el.find('.follow').hide()
      window.showSuccess(I18n.t('customer.dashboard.conversations.interactions.follow_ok'))
      @ticket.trigger('action:follow')
    )

    @listenTo(@interaction, 'interaction:retweet', (response) =>
      @$el.find('.retweet').hide()
      if (response.success || response.message.indexOf("already retweet") != -1)
        window.showSuccess(I18n.t('customer.dashboard.conversations.interactions.rt_ok'))
      else
        window.showError(response.message)
    )

    @listenTo(@interaction, 'interaction:favorite', (response) =>
      @$el.find('.favorite').hide()
      if (response.success || response.message.indexOf("already favorited") != -1)
        window.showSuccess(I18n.t('customer.dashboard.conversations.interactions.fav_ok'))
      else
        window.showError(response.message)
    )

    @listenTo(@interaction, 'interaction:like', =>
      @$el.find('.like').addClass('hidden')
      @$el.find('.unlike').removeClass('hidden')
      window.showSuccess(I18n.t('customer.dashboard.conversations.interactions.like_ok'))
    )

    @listenTo(@interaction, 'interaction:unLike', =>
      @$el.find('.like').removeClass('hidden')
      @$el.find('.unlike').addClass('hidden')
      window.showSuccess(I18n.t('customer.dashboard.conversations.interactions.unlike_ok'))
    )

    @listenTo(@interaction, 'interaction:react', =>
      @$el.find('.react').addClass('hidden')
      @$el.find('.unreact').removeClass('hidden')
      window.showSuccess(I18n.t('customer.dashboard.conversations.interactions.react_ok'))
    )

    @listenTo(@interaction, 'interaction:unreact', =>
      @$el.find('.react').removeClass('hidden')
      @$el.find('.unreact').addClass('hidden')
      window.showSuccess(I18n.t('customer.dashboard.conversations.interactions.unreact_ok'))
    )

    @listenTo(@interaction, 'interaction:author_info:loaded', @authorInfoLoaded)
    @listenTo(Backbone, 'interactions:finished_loading', @displayAttachmentScroll)
    @listenTo(@ticketView.model, 'change:can_reply', @updateFollowButtonAndReplyVisibility)

  updateFollowButtonAndReplyVisibility: =>
    # TODO: a separate view should be responsible for the .user-profile-actions div
    if !@model.get('responseInteraction')
      @render()

  findTemplate: ->
    specificities = [
      [@model.type(), @model.subType(), @ticketType()],
      [@model.groupType(), @model.type(), @ticketType()],
      [@model.groupType(), @ticketType()],
      [@model.type(), @ticketType()]
    ]
    specificities.push(['inbox', 'interaction']) if @notFoundContent()
    templates = _.map(specificities, (s) -> JST["backbone/templates/customer/ticket/#{s.join('/')}"])

    ret = _.find(templates, (t) -> t)
    unless ret
      message = "Template for interaction does not exist #{JSON.stringify(@model.attributes)}"
      console.warn(message)
      jsLogger.fatal(message)
    ret

  getModel: ->
    if @ticketView
      model = @ticketView.model
    else
      model = @options.model
    model

  _starRating: ->
    if (@model.get('data').comment.starRating)  #todo remove that
      @model.get('data').comment.starRating
    else
      @model.get('data').userComment.starRating


  isPrivateMessage: ->
    _.isEqual(@model.get('available_reply_visibility'), ['private'])

  firstInteractionIsPublic: ->
    model = @getModel()
    if model.type() == "twitter"
      return model.subType() != "direct-message"
    if model.type() == "facebook"
      return !model.isFacebookMessage()
    if model.type() == "instagram"
      return model.subType() == "ig-message"
    return false

  onFollow: ->
    @_keepCustomerSessionAlive()
    return if @model.get('responseInteraction') || !@canFollow()
    @interaction.follow()

  onRetweet: ->
    @_keepCustomerSessionAlive()
    swal({
        title: 'Retweet?'
        type: 'info'
        showCancelButton: true
        confirmButtonClass: 'btn-danger'
        confirmButtonText: I18n.t('customer.dashboard.conversations.interactions.yes')
        cancelButtonText: I18n.t('customer.dashboard.conversations.interactions.cancel')
        closeOnConfirm: true
      }, => @interaction.retweet())

  onFavorite: ->
    @_keepCustomerSessionAlive()
    return if @model.get('responseInteraction')
    swal({
      title: I18n.t('customer.dashboard.conversations.interactions.fav_alert')
      type: 'info'
      showCancelButton: true
      confirmButtonClass: 'btn-success'
      confirmButtonText: I18n.t('customer.dashboard.conversations.interactions.yes')
      cancelButtonText: I18n.t('customer.dashboard.conversations.interactions.cancel')
      closeOnConfirm: true
    }, => @interaction.favorite())

  onLike: ->
    @_keepCustomerSessionAlive()
    swal({
      title: I18n.t('customer.dashboard.conversations.interactions.like_alert')
      type: 'info'
      showCancelButton: true,
      confirmButtonClass: 'btn-success'
      confirmButtonText: I18n.t('customer.dashboard.conversations.interactions.yes')
      cancelButtonText: I18n.t('customer.dashboard.conversations.interactions.cancel')
      closeOnConfirm: true
    }, => @interaction.like())

  onUnlike: ->
    @_keepCustomerSessionAlive()
    @interaction.unLike()

  _onReact: ->
    @_keepCustomerSessionAlive()
    swal({
      title: I18n.t('customer.dashboard.conversations.interactions.react_alert')
      type: 'info'
      showCancelButton: true,
      confirmButtonClass: 'btn-success'
      confirmButtonText: I18n.t('customer.dashboard.conversations.interactions.yes')
      cancelButtonText: I18n.t('customer.dashboard.conversations.interactions.cancel')
      allowOutsideClick: true
    }, => @interaction.react())

  _onUnreact: ->
    @_keepCustomerSessionAlive()
    @interaction.unreact()

  openResponseBox: ({responseTo = @model.get('interaction_id')}) =>
    @_keepCustomerSessionAlive()
    @ticketView.closeAllResponseBoxes()
    if @ticketView.model.isEmail()
      @responseView?.onDetach() if @responseView
      @responseView = new Customer.Dashboard.TicketEmailResponseView(@_responseViewOptions(responseTo))
    else
      if @ticketView.model.isFacebook()
        @responseView = new Customer.Dashboard.FacebookTicketResponseView(@_responseViewOptions(responseTo))
      else if @ticketView.model.isInstagram()
        @responseView =  if @model.subType() == 'ig-message'
          new Customer.Dashboard.InstagramMessageTicketResponseView(@_responseViewOptions(responseTo))
        else
          new Customer.Dashboard.InstagramCommentTicketResponseView(@_responseViewOptions(responseTo))
      else
        @responseView = new Customer.Dashboard.TicketResponseView(@_responseViewOptions(responseTo))
    @listenTo(@responseView, 'note:saved', (content) => @ticketView.model.notes.create({content: content}, wait: true))
    @listenTo(@responseView, 'response:success', @_handleResponseSuccess)
    @listenTo(@responseView, 'onHide', => @closeResponseBox())
    @listenTo(@responseView, 'ticket:tab:closeRequired', @_closeTicketTab)
    @listenTo(@responseView, 'validations:failed', @ticketView.onValidationFail)
    @$el.find(@formContainerSelector).html(@responseView.render().el).show()
    @hideResponse()
    if !@ticketView.model.isEmail()
      Backbone.trigger('interactionResponseBox:open', @responseView)
    else
      @responseView.scrollToTextBox()

  _responseViewOptions: (responseTo) ->
    ticketView: @ticketView
    socialAccounts: @options.socialAccounts
    enabled_email_social_accounts: @options.enabled_email_social_accounts
    notes: true
    responseTo: responseTo
    responseText: @responseInitialText()
    subject: @model.getValue?('subject') || ''
    boxSize: 1
    responseTemplates: @options.responseTemplates
    tags: @model.tags()
    mainResponse: false
    user: @model.name()
    username: @model.username()
    isPrivate: @isPrivateMessage()
    email_multi_threadkey_enabled: @ticketView.options.email_multi_threadkey_enabled
    labels: @model.labels()

  _handleResponseSuccess: (response) =>
    if @ticketView.getTicket().isByUser() || @ticketView.getTicket().type() == 'email' || @ticketView.getTicket().type() == 'tiktok'
      @ticketView.onResponse(response)
    else
      @ticketView.updateAfterResponse(response)
      @childSocialContents.push new Monitoring.Models.SocialContents.AnalysisUnitFactory().create(
        response.response_interaction,
        @ticketView.model.tags
      )
      avoidDuplications = false
      @render(avoidDuplications)
    @closeResponseBox()

  responseInitialText: ->
    if @isSecondLevelComment()
      "#{@model.getValue('nombre')} "
    else
      ''

  closeResponseBox: =>
    @_keepCustomerSessionAlive()
    if @ticketView.model.isEmail()
      @responseView?.onDetach() if @responseView
    @responseView.destroy() if @responseView
    @responseView = undefined
    @$el.find('.form-container').hide()
    @showResponse()
    Backbone.trigger('interactionResponseBox:close')

  render: (avoidDuplications = true) ->
    @$el.html(@template(
      socialContent: @model
      userProfile:
        avatar: @userProfileData?.avatar || @model.avatar()
        name: @userProfileData?.name || @model.name()
        username: @userProfileData?.username || @model.username?()
      conversation: @ticketView.model
      icons: @iconFilenamesBySubtype()
      options:
        can_reply: @ticketView.model.get('can_reply')
        number_of_interactions: @_numberOfInteractions()
        can_follow: @canFollow()
        privateInteractionOnPublicContent: @interaction.get('privateInteractionOnPublicContent')
        notFoundContent: @notFoundContent()
        interactionType: @interaction.get('interactionType')
        replyButtonEnabled: @interaction.get('replyButtonEnabled')
        subType: @model.subType()
        cutTicketEnabled: @canCut() && !@cutTicketButtonDisabled && !@isBrandContent() && @ticket.attributes.assigned_to_id == Keepcon.current_user.id
    ))
    @$el.find('div.sentiment').html(
      new Monitoring.Views.SentimentView(model: @model, centerToolbar: false).render().el
    )
    @$el.find('.inbox-post-picture').prepend(
      new Monitoring.Views.SocialContents.SocialContentMediaView(
        socialContent: @model
      ).render().el
    )

    if @ticket.isGooglePlay() and !@notFoundContent()
      @showStars(@_starRating())

    @socialContentTagsView = new Monitoring.Dashboard.SocialContentTagsView({
      possibleTags: @model.possibleTags()
      selectedTagCodes: @model.get('tags')
      suggestedTags: @model.suggestedTags()
      withIconAndLabel: true
      toggleableControls: true
      showAddNewTags: @ticket.isEmail()
    })
    @socialContentTagsView.bind('changed:tags', @_updateInteraction)
    @$el.find('.tags').html(@socialContentTagsView.render())

    @$el.find('.note').popover()
    @$el.find('.tooltip-action').tooltip()
    @$el.find('.sc-picture-preview').magnificPopup(type: 'image', closeOnContentClick: true)
    profileLink = @$el.find('.user-profile-links')
    # This event can't be defined on top with the others
    # because the third parameter defaults to false
    profileLink.get(0).addEventListener('click', @showProfile, true) if profileLink.length > 0
    @$el.toggleClass('response-from-client', @isBrandContent())
    @renderSchedule() if @hasSchedule()
    @avoidDuplications() if avoidDuplications
    if @notFoundContent()
      @$el.addClass('not-found-interaction-clearfix')
      div = $("<div class='not-found-interaction'></div>")
      @$el.prepend(div)
    @interaction.loadAuthorInfo()
    if @ticket.isAppStore() and !@notFoundContent()
      @showStars(@_appStoreStarRating())
    if @ticket.isGoogleMyBusiness() and !@notFoundContent()
      @showStars(@_googleMyBusinessRating())
    @checkHtml() if @model.isEmail()
    @addWhatsApp() if @model.isWhatsapp()
    @_addSurveyStart() if @_isSurveyStartingInteraction(@model)
    @_addOngoingSurvey() if @_isPartOfASurveyProcess(@model)
    @_addSurveyEnd() if @_isSurveyEndingInteraction(@model)
    @_addSurveyNotice() if @model.get 'is_survey_delivery'
    @_addInstagramUnsupportedIcon() if @_isInstagramUnsupportedMessage()
    @_addInstagramMedia() if @_isInstagramMedia()
    @_addInstagramStories() if @_isInstagramStoryMention()
    if @$el.find('.interaction').hasClass('with-limited-height')
      @addShowEntireMessageButton()
    @$el.find('.interaction-content-container img').load(@addShowEntireMessageButton)
    @

  showStars: (rating) ->
    reviewStarsView = new Monitoring.Views.ReviewStarsView()
    @$el.find('#comment-review-stars').html(reviewStarsView.render().el)
    reviewStarsView.setRating(rating) if rating

  _appStoreStarRating: ->
    if(this.model.attributes.data.appStoreData.user_id == "Developer")
      this.model.attributes.data.appStoreData.parent.rating
    else
      this.model.attributes.data.appStoreData.rating

  _googleMyBusinessRating: ->
    googleMyBusinessContent = @model.get('content')
    if googleMyBusinessContent.isBrandContent()
      googleMyBusinessContent.getReviewSnapshot().getStarRating()
    else
      googleMyBusinessContent.getStarRating()

  notFoundContent: ->
    @model.isNotFound()

  isBrandContent: ->
    @model.isBrandContent()

  iconFilenamesBySubtype: ->
    {
      fb_post: 'facebook-post-icon.png'
      fb_comment: 'facebook-comment-icon.png'
      fb_reply_comment: 'facebook-reply-comment-icon.png'
      fb_message: 'facebook-message-icon.png'
      tweet: 'twitter-tweet-icon.png'
      tw_reply: 'twitter-reply-icon.png'
      quote: 'twitter-quote-icon.png'
      direct_message: 'twitter-direct-message-icon.png'
      ig_image: 'instagram-image-icon.png'
      ig_message: 'instagram-comment-icon.png'
      ig_video: 'instagram-video-icon.png'
      ig_comment: 'instagram-comment-icon.png'
      yt_video: 'youtube-video-icon.png'
      yt_comment: 'youtube-comment-icon.png'
      email: 'email-icon.png'
      webchat_message: 'chat-message.png'
      li_comment: 'linkedin-comment-icon.png'
      li_post: 'linkedin-post-icon.png'
    }

  isResponseFromClient: ->
    @model.isResponseFromClient()

  isStartingInteraction: ->
    @model.isStartingInteraction()

  addShowEntireMessageButton: =>
    if (not @interactionHtmlContent() || not @interactionHtmlContent().offsetHeight)
      setTimeout(@addShowEntireMessageButton, 10)
    else
      thereIsOverflow = @interactionHtmlContent().offsetHeight < @interactionHtmlContent().scrollHeight
      if thereIsOverflow && !@showMoreButtonExists()
        @interactionContent().addClass('with-overflow')
        $showMoreButton = $($.parseHTML('<div class="show-more-interaction-content"></div>'))
        @interactionContent().after($showMoreButton).addClass('expandable')
        @updateShowEntireMessageButton()
        $showMoreButton.click(
          () =>
            @interactionContent().toggleClass('show-more')
            @ticketView.focusInteractionBox(@) unless @interactionContent().hasClass('show-more')
            @updateShowEntireMessageButton()
        )

  showMoreButtonExists: =>
    @$el.find('.show-more-interaction-content').length > 0

  updateShowEntireMessageButton: =>
    $showMoreButton = @$el.find('.show-more-interaction-content')
    $showMoreButton.html(
      if @interactionContent().hasClass('show-more')
        I18n.t('monitoring.dashboard.applied_filters.show_less')
      else
        I18n.t('monitoring.dashboard.applied_filters.show_more')
    )

  showProfile: (e) =>
    @_keepCustomerSessionAlive()
    e.stopPropagation()
    return if @model.get('responseInteraction')
    @trigger('clicked:user', @model)

  _isSurveyStartingInteraction: (model) =>
    @model.get 'is_survey_starting_interaction'

  _isPartOfASurveyProcess: (model) =>
    @model.get 'is_survey_ongoing_interaction'

  _isLastOngoingSurveyInteraction: (model) =>
    @model.get('is_survey_ongoing_interaction') && @model.get('is_survey_ongoing_last_interaction')

  _isSurveyEndingInteraction: (model) =>
    @model.get 'is_survey_ending_interaction'

  _markAsNotTheLastOngoingSurvey: =>
    if @_isLastOngoingSurveyInteraction(@model) || @_isSurveyEndingInteraction(@model)
      @model.set('is_survey_ongoing_interaction', true)
      @model.set('is_survey_ongoing_last_interaction', false)
      @model.set('is_survey_ending_interaction', false)

  _numberOfInteractions: ->
    count = 0
    _.each(@ticketView.model.interactions, (interaction) ->
      count++ unless interaction.isResponseFromClient()
    )

    count

  _updateInteraction: (tags) =>
    if @model.isFacebook() && _.any(tags, (tag) => @interaction.impliesRejection(tag))
      swal({
          title: 'This action will reject the content. Are you sure?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn-danger',
          confirmButtonText: 'Yes',
          closeOnConfirm: true
        }, (isConfirm) => if isConfirm then @_updateTags(tags) else @render()
      )
    else
      @_updateTags(tags)

  _updateTags: (tags) =>
    return if @model.get('responseInteraction')
    @interaction.updateTags(tags)

  addWhatsApp: ->
    @$el.addClass 'whatsapp-message'

  _addSurveyNotice: ->
    @$el.addClass 'with-survey-notice'
    @$el.prepend new Customer.Ticket.SurveyNoticeView(
      datetime: @model.created_at_ISO()
    ).render().el

  _addSurveyStart: ->
    @$el.addClass 'survey-process-start'
    @$el.prepend new Customer.Ticket.SurveyStartingView(
      datetime: @model.created_at_ISO()
    ).render().el

  _addOngoingSurvey: ->
    if @_isLastOngoingSurveyInteraction()
      @$el.addClass 'last-ongoing-survey-interaction'
      @$el.append new Customer.Ticket.OngoingSurveyView(
        datetime: @model.created_at_ISO()
      ).render().el
    else
      @$el.addClass 'is-part-of-ongoing-survey-process'

  _addSurveyEnd: ->
    @$el.addClass 'survey-process-end'
    @$el.append new Customer.Ticket.SurveyEndingView(
      datetime: @model.created_at_ISO()
    ).render().el

  updateVisibilityByPrivacy: (privacy) ->
    # privacy is 'all', 'only-public' or 'only-private'
    if (privacy == 'all') || (privacy == 'only-public' && @model.privacy() == 'public') || (privacy == 'only-private' && @model.privacy() == 'private')
      @show()
    else
      @hide()

  show: ->
    @$el.css('display', 'block')

  hide: ->
    @$el.css('display', 'none')


  subType :->
   @model.subType()

  destroy: ->
    @model.destroy()
    this.remove()
    false

  hideResponse: =>
    @$el.find('.openResponseBox').hide()
    @$el.find('.openResponseBox').closest(".action").hide()

  showResponse: =>
    @$el.find('.openResponseBox').show()
    @$el.find('.openResponseBox').closest(".action").show()

  last: ->
    @model.get('interaction_id') == @ticketView.model.get('dialogue').last_interaction_id

  canFollow: ->
    @model.type() == 'twitter' && !@interaction.followingAuthor() && !@isBrandContent()

  _onUpdateSuccess: (response) ->
    if @model.getValue != undefined
      attachments = @model.getValue("attachments") || []
      response.social_content.data.content["attachments"] = attachments
    @model.set(response.social_content)
    @render(false)

  _onUpdateError: (response) ->
    if response.message
      showError response.message
    else
      showError I18n.t('generic_error_message')
      jsLogger.error 'Error updating interaction. Response: ' + JSON.stringify response

  isSecondLevelComment: ->
    @model.newSubType() == 'fb-reply-comment'

  authorInfoLoaded: =>
    if @interaction.followingAuthor()
      @$el.find('.follow').hide()
      authorInfoView = new Customer.Ticket.AuthorInfoView(@interaction.authorInfo)
      @$el.find('.author-info').html(authorInfoView.render().el)

  showContext: =>
    @_keepCustomerSessionAlive()
    @$el.find('.social-content-context').remove()
    contextModalContainer = $('<div>').addClass('social-content-context')
    @$el.append(contextModalContainer)
    contextView = Monitoring.Views.SocialContentContextView.for(@model)
    contextModalContainer.append(contextView.render().el)
    contextView.newSearch()
    false

  editTags: (event) =>
    @_keepCustomerSessionAlive()
    event.preventDefault()
    @socialContentTagsView.showTagsEditor()
    @$el.find('#whatsapp-tags').toggleClass("hidden")

  doCut:=>
    socialContentId =  @interaction.attributes.interactionId
    json = new FormData();
    json.append('interactionId', socialContentId)
    json.append('ticketId',@ticket.attributes.id)
    $.ajax({
      method: 'POST',
      url: '/customer/cut_ticket/cut_ticket',
      dataType: 'json',
      data: json,
      contentType: false,
      processData: false
      success: (response) =>
        if !response.error
          showInformation(I18n.t('customer.dashboard.conversations.ticket_cut'))
          @ticketView.disableActionsAfterCut()
        else
          showError(response.message)
          @ticketView.enableAllCutTicketButtons()
      error: (response) =>
        showError(I18n.t('customer.dashboard.conversations.can_not_cut_ticket'))
        @ticketView.enableAllCutTicketButtons()
    })

  cutTicket: (event) =>
    event.stopImmediatePropagation()
    @ticketView.disableAllCutTicketButtons()
    @showConfirmationModal()

  showConfirmationModal: =>
    _title = I18n.t('monitoring.arrival_alerts.confirmation.are_you_sure')
    _aditional_text = I18n.t('customer.dashboard.conversations.cut_confirmation_modal')
    swal({
      title: _title
      text: _aditional_text
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.confirm')
      cancelButtonText: I18n.t('customer.dashboard.conversations.details.close_ticket_confirmation.cancel')
      closeOnConfirm: true
      }, (isConfirm) => if isConfirm then @doCut() else @ticketView.enableAllCutTicketButtons()
    )

  disableCutTicketButton: =>
    unless @cutTicketButtonDisabled
      @cutTicketButtonDisabled = true
      @render(false)

  onMouseOverCutTicket: =>
    @$el.find('.cut-ticket-separator').css({opacity: 0.0, visibility: "visible"}).animate({opacity: 1.0}, 200)

  onMouseOutCutTicket: =>
    @$el.find('.cut-ticket-separator').css({opacity: 0.0, visibility: "hidden"}).animate({opacity: 1.0}, 200)


  printInteraction: ({interaction_id = @model.get('interaction_id')}) =>
    event.preventDefault()
    window.open("/customer/interactions/#{interaction_id}/print")

  checkHtml: =>
    if @model.getValue('text_html')
      html_default = @interactionVisualizationDefault.email || 'html'
      if html_default == 'plain' then @renderTextWithoutHtml() else @renderTextWithHtml()
    else
      $(@$el.find('.text-with-html')[0]).prop('disabled', true)
      $(@$el.find('.text-with-html')[0]).addClass('disabled')
      @$el.find('.text-with-html')[0].title = I18n.t('customer.dashboard.errors.email_html_format_not_available')

  renderTextWithHtml: =>
    $(@$el.find('.text-without-html')[0]).removeClass('active')
    $(@$el.find('.text-with-html')[0]).addClass('active')
    unsafeHtml = @model.getValue('text_html') || "<span>#{@model.enhancedContent('text')}</span>"
    @sanitizeAndAddToDOM(unsafeHtml)

  renderTextWithoutHtml: =>
    $(@$el.find('.text-without-html')[0]).addClass('active')
    $(@$el.find('.text-with-html')[0]).removeClass('active')
    unsafeHtml = "<span>#{@model.enhancedContent('text')}</span>"
    @sanitizeAndAddToDOM(unsafeHtml)

  sanitizeAndAddToDOM: (unsafeHtml) =>
    @$el.find('.interaction-content-text')[0].innerHTML = DOMPurify.sanitize(unsafeHtml)

  switchToTextWithHtml: (evt) =>
    @renderTextWithHtml()
    evt.stopPropagation()

  switchToTextWithoutHtml: (evt) =>
    @renderTextWithoutHtml()
    evt.stopPropagation()

  hasSchedule: ->
    @model.get('schedule')

  getSchedule: ->
    new Customer.ResponseSchedule(@model.get('schedule'))

  renderSchedule: ->
    schedule = @getSchedule()
    @scheduleView = new Customer.Ticket.InteractionScheduleView(schedule: schedule, canEdit: @canEditSchedule())
    @listenTo(@scheduleView, 'updateSchedule:staleDialogue', (response) =>
      @ticketView.trigger('refresh:tab')
    )
    @$el.append(@scheduleView.render().$el)
    $(".schedule-id-#{schedule.id}").remove()
    @$el.addClass("schedule-id-#{schedule.id}")

  canEditSchedule: ->
    @canReply()

  canReply: ->
    @ticketView.model.get('can_reply')

  canCut: ->
    distinguishedContent = @ticketView.getDistinguishedContent()
    if distinguishedContent && distinguishedContent.id == @model.id
       false
    else
      true


  isWebchat: ->
    @model.type() == "webchat"

  avoidDuplications: ->
    uniqueIdClass = @externalIdClass()
    if uniqueIdClass
      $(".#{uniqueIdClass}").remove()
      @$el.addClass(uniqueIdClass)

  externalIdClass: ->
    discriminator = @model.externalId()
    if discriminator && discriminator != '' && discriminator != '__not_generated_yet__'
      "external-id-#{UniqueId.get(discriminator)}"
    else
      null

  onDetach: ->
    @responseView?.onDetach()

  onAttach: ->
    @responseView?.onAttach()

  interactionContent: ->
    if @$el.find('.interaction-content-text')
      @$el.find('.interaction-content-text')
    else
      @$el.find('.interaction-content-container')

  interactionHtmlContent: ->
    @interactionContent()[0]

  removeReplyButton: ->
    $(@$el.find('.openResponseBox')).remove()

  removeCutTicketButton: ->
    $(@$el.find('.cut-ticket')).remove()

  disableCutTicketBtn: ->
    @$el.find('.cut-icon').prop('disabled', true)
  enableCutTicketBtn: ->
    @$el.find('.cut-icon').prop('disabled', false)

  scrollAttachmentsBackwards: =>
    if @canScrollAttachmentsBackwards()
      @$el.find(".attachments-section").find(".sc-attachment.d-none").last().removeClass("d-none")
      unless @canScrollAttachmentsBackwards()
        @$el.find(".attachment-scroll-backwards").find("i").addClass("disabled")
      @$el.find(".attachment-scroll-forwards").find("i").removeClass("disabled")

  scrollAttachmentsForwards: =>
    if @canScrollAttachmentsForwards()
      @$el.find(".attachments-section").find(".sc-attachment").not(".d-none").first().addClass("d-none")
      unless @canScrollAttachmentsForwards()
        @$el.find(".attachment-scroll-forwards").find("i").addClass("disabled")
      @$el.find(".attachment-scroll-backwards").find("i").removeClass("disabled")


  canScrollAttachmentsBackwards: =>
    hiddenPreviousAttachments = @$el.find(".attachments-section").find(".sc-attachment.d-none")
    return hiddenPreviousAttachments.length > 0

  canScrollAttachmentsForwards: =>
    attachmentSectionWidth = @attachmentSectionVisibleWidth()
    singleAttachmentWidth = @$el.find(".attachments-section").find(".sc-attachment").width()
    a = @$el.find(".attachments-section")
    visibleAttachments = @$el.find(".attachments-section").find(".sc-attachment").not(".d-none").length
    return (visibleAttachments * singleAttachmentWidth) > attachmentSectionWidth

  attachmentSectionVisibleWidth: =>
    return @$el.find(".interaction-content-container").width() - 140

  displayAttachmentScroll: =>
    if @canScrollAttachmentsForwards()
      @$el.find('.attachment-scroll-backwards').removeClass('d-none')
      @$el.find('.attachment-scroll-forwards').removeClass('d-none')
    else
      @$el.find(".attachment-scroll-backwards").addClass("d-none")
      @$el.find(".attachment-scroll-forwards").addClass("d-none")

  onPermalink: ->
    @_keepCustomerSessionAlive()

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  _closeTicketTab: =>
    @ticketView.closeTicketTab()

  _isInstagramUnsupportedMessage: ->
    @model.isInstagramMessage() && @_instagramMessageType() == 'unsupported'

  _isInstagramMedia: ->
    @model.isInstagramMessage() && @_instagramMessageType() == 'media'

  _isInstagramStoryMention: =>
    @model.isInstagramMessage() && @_instagramMessageType() == 'story_mention'

  _instagramMessageType: ->
    @model.get('data').message.message_type

  _addInstagramUnsupportedIcon: ->
    @$el.addClass('instagram-unsupported-message')
    iconView = if @_instagramMessage().isKeepconUnsupported
      @_unsupportedByKeepconIcon()
    else
      @_unsupportedByInstagramIcon()
    @$el.find('.interaction-content-container p').prepend(iconView.render().el)

  _addInstagramMedia: ->
    attachments = @_instagramMessage().attachments
    instagramAttachments = _.object(
      ["#{type}s", @_getAttachments(attachments, type)] for type in ['image', 'video', 'audio', 'file']
    )
    @attachmentsView = new Monitoring.Views.SocialContents.SocialContentAttachmentsView
      instagramAttachments: instagramAttachments
      useVideoIcon: instagramAttachments.videos.length > 0
    @$el.find('.interaction-content-container p').replaceWith(@attachmentsView.render().el)

  _addInstagramStories: =>
    attachments = @_instagramMessage().attachments
    instagramStories = _.flatten([@_getAttachments(attachments, type)] for type in ['image', 'video'])
    @attachmentsView = new Monitoring.Views.SocialContents.SocialContentAttachmentsView
      instagramStories: instagramStories
      instagramStoriesAreExpired: @_instagramMessage().storiesAreExpired()
      useVideoIcon: instagramStories[0].type == Common.AttachmentType.VIDEO
    @$el.find('.interaction-content-container p').replaceWith(@attachmentsView.render().el)
    @$el.find('.interaction-content-container .sc-attachments').addClass('instagram-stories-container')

  _instagramMessage: ->
    @model.get('content').message

  _getAttachments: (attachments, type) ->
    _.select(attachments, (attachment) -> attachment.type == type)

  _unsupportedByKeepconIcon: ->
    new Common.SvgIconView(
      svgPath: 'icons/unsupported-by-keepcon.svg'
      svgId: 'unsupported-by-keepcon'
      iconClass: 'unsupported-message-icon'
    )

  _unsupportedByInstagramIcon: ->
    new Common.SvgIconView(
      svgPath: 'icons/unsupported-by-instagram.svg'
      svgId: 'unsupported-by-instagram'
      iconClass: 'unsupported-message-icon'
    )
